<template>
  <UISkeletonLoaderSPA />
</template>

<script lang="ts" setup>
import { useAuthRedirect } from '@manager/composables/use-auth-redirect';
import { useQueryParameter } from '@manager/composables/use-query-value';
import { getDefaultLandingPage } from '@manager/router';
import { routeNames } from '@manager/router/route-names';
import { useAuthStore } from '@manager/store/auth-store';
import { captureException } from '@sentry/vue';
import UISkeletonLoaderSPA from 'shared/ui/registry/kinnovis/ui-skeleton-loaders/UISkeletonLoaderSPA.vue';
import { onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter();
const { consumeRedirectUrl } = useAuthRedirect();
const stateQueryParam = useQueryParameter('state', 'string');
const codeQueryParam = useQueryParameter('code', 'string');
const errorQueryParam = useQueryParameter('error', 'string');
const error = ref<string | undefined>(errorQueryParam.value);
const authStore = useAuthStore();

onMounted(() => {
  if (authStore.isAuthenticated) return;

  if (!errorQueryParam.value) {
    if (stateQueryParam.value && codeQueryParam.value) {
      error.value = undefined;
      authStore
        .fetchToken(stateQueryParam.value, codeQueryParam.value)
        .then(() => {
          const redirectUrl = consumeRedirectUrl();
          if (redirectUrl) {
            router.replace(redirectUrl);
          } else {
            router.replace({ name: getDefaultLandingPage() });
          }
        })
        .catch((responseError) => {
          captureException(responseError);
          error.value = responseError.message;
        });
    } else {
      router.replace({ name: routeNames.login });
    }
  }
});
</script>

<style scoped lang="scss"></style>
